<template>
    <div class="mapbox">
        <div id="mapContainer" class="mapbox__container"></div>
        <div class="mapbox__side-bar">
            <h1 class="main-header">Discover</h1>
            <ul id="map-tabs"></ul>
        </div>
    </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import mainMap from '../assets/mapbox-data/main-map.json';
import mainMapLines from '../assets/mapbox-data/main-map-line.json';
import gippsMap from '../assets/mapbox-data/gipps-land.json';
import stateLines from '../assets/mapbox-data/state-lines.json';
import gippsMapLines from '../assets/mapbox-data/gipps-land-lines.json';
import drivingHours from '../assets/mapbox-data/driving-hours.json';
import drivingRoutes from '../assets/mapbox-data/driving-routes.json';
import drivingMarkers from '../assets/mapbox-data/driving-markers.json';
import drivingLines from '../assets/mapbox-data/driving-lines.json';
import parkMarkers from '../assets/mapbox-data/park-markers.json';
import parkPlacesPoints from '../assets/mapbox-data/park-places-points.json';
import drivingRoutesSegmented from '../assets/mapbox-data/driving-routes-segmented.json';
import placesPoints from '../assets/mapbox-data/places-points.json';
import mapLabels from '../assets/mapbox-data/map-labels.json';
import lakePolygons from '../assets/mapbox-data/lakes-polygon.json';
import lakeLines from '../assets/mapbox-data/lakes-line.json';

import seaImage from '../assets/images/sea.png';
import whiteOverlay from '../assets/images/white-radial.png';
import mapMarker from '../assets/images/map-marker.png';
import mapMarkerHalf from '../assets/images/map-marker-half.png';
import arrowBlue from '../assets/images/arrow-blue.png';
import arrowGray from '../assets/images/arrow-gray.png';
import circleMarkerBlue from '../assets/images/circle-marker-blue.png';
import circleMarkerGray from '../assets/images/circle-marker-gray.png';
import circleMarkerGreen from '../assets/images/circle-marker-green.png';
import circleMarkerCar from '../assets/images/circle-marker-car.png';
import circleMarkerCar45 from '../assets/images/circle-marker-car-45.png';
import circleMarkerCar1 from '../assets/images/circle-marker-car-1.png';
import circleMarkerCar15 from '../assets/images/circle-marker-car-1-5.png';
import circleMarkerCar2 from '../assets/images/circle-marker-car-2.png';
import circleMarkerCar35 from '../assets/images/circle-marker-car-3-5.png';
import circleMarkerCar75 from '../assets/images/circle-marker-car-7-5.png';
import circleMarkerLeaf from '../assets/images/circle-marker-leaf.png';
import driveMarker from '../assets/images/drive-marker.png';

export default {
    name: "Mapbox",
    data() {
        return {
            accessToken: 'pk.eyJ1IjoiZXZvbHV0aW9uNyIsImEiOiJjaW12Y3d2bHQwMnVpdmhtNDFpdXVldm1mIn0.2WCxjgecGjG0hK_azGZJTg',
            mapStyle: 'mapbox://styles/evolution7/ckevdj35i0gmk19le27pfcplw',
            bounds: [
                [142.222, -40.172], // Southwest coordinates
                [151.481, -35.221] // Northeast coordinates
            ],
            hoveredStateId: null,
            popUpContainer: null,
            openedPopupName: null,
            numOfRegions: 4,
            minZoom: 6.9,
            maxZoom: 8,
            mapMarkers: [
                {
                    name: 'map-marker',
                    img:  mapMarker
                },
                {
                    name: 'map-marker-half',
                    img:  mapMarkerHalf
                },
                {
                    name: 'arrow-blue',
                    img:  arrowBlue
                },
                {
                    name: 'arrow-gray',
                    img:  arrowGray
                },
                {
                    name: 'circle-marker-blue',
                    img:  circleMarkerBlue
                },
                {
                    name: 'circle-marker-gray',
                    img:  circleMarkerGray
                },
                {
                    name: 'circle-marker-green',
                    img:  circleMarkerGreen
                },
                {
                    name: 'circle-marker-car',
                    img:  circleMarkerCar
                },
                {
                    name: 'circle-marker-car-45',
                    img:  circleMarkerCar45
                },
                {
                    name: 'circle-marker-car-1',
                    img:  circleMarkerCar1
                },
                {
                    name: 'circle-marker-car-1-5',
                    img:  circleMarkerCar15
                },
                {
                    name: 'circle-marker-car-2',
                    img:  circleMarkerCar2
                },
                {
                    name: 'circle-marker-car-3-5',
                    img:  circleMarkerCar35
                },
                {
                    name: 'circle-marker-car-7-5',
                    img:  circleMarkerCar75
                },
                {
                    name: 'circle-marker-leaf',
                    img:  circleMarkerLeaf
                },
                {
                    name: 'drive-marker',
                    img:  driveMarker
                }
            ],
            selectedTab: "regions",
            mapTabs: [
                {
                    id: "regions",
                    name: "Regions",
                    visibleLayers: [
                        "lakes-polygon-layer",
                        "lakes-lines-layer",
                        "region-places-points-layer",
                        "region-custom-label-layer",
                        "gipps-map-layer",
                        "gipps-map-lines-layer"
                    ],
                },
                {
                    id: "drive-times",
                    name: "Drive Times",
                    visibleLayers: [
                        "gipps-map-blue-layer",
                        "driving-routes-layer",
                        "driving-routes-layer-stroke",
                        "driving-markers-layer",
                        "gipps-map-lines-layer-blue",
                        "driving-lines-layer",
                        "driving-routes-segmented-layer",
                        "driving-hours-markers-layer"
                    ],
                },
                {
                    id: "national-parks",
                    name: "National Parks",
                    visibleLayers: [
                        "gipps-map-green-layer",
                        "gipps-map-lines-layer-green",
                        "park-markers-layer",
                        "park-places-points-layer",
                        "lakes-polygon-layer",
                        "lakes-lines-layer"
                    ],
                }
            ],
            panEnabledWindowSize: window.matchMedia("(max-width: 1279px)"),
        };
    },
    mounted() {
        this.createMap();
    },
    methods: {
        createMap() {
            // instantiate map.  this method runs once after the vue component is mounted to the dom
            this.map = new mapboxgl.Map({
                accessToken: this.accessToken,
                container: "mapContainer",
                style: this.mapStyle,
                center: [148.84, -37.805],
                zoom: this.minZoom,
                minZoom: this.minZoom,
                maxZoom: this.maxZoom,
                maxBounds: this.bounds,
            });
            this.map.scrollZoom.disable();
            this.map.doubleClickZoom.disable();

            const navControl = new mapboxgl.NavigationControl({
                showCompass: false,
                showZoom: true
            });

            this.map.addControl(navControl, "top-right");

            this.map.dragRotate.disable();
            this.map.touchZoomRotate.disableRotation();

            this.map.on("load", () => {
                const self = this;

                this.mapMarkers.forEach(function (marker, index) {
                    self.map.loadImage(marker.img,
                        function (error, image) {
                            if (error) throw error;
                            self.map.addImage(marker.name, image, {
                                pixelRatio: 2
                            });
                        }
                    )
                });

                this.map.addSource('main-map', {
                    'type': 'geojson',
                    'data': mainMap
                });
                this.map.addSource('main-map-lines', {
                    'type': 'geojson',
                    'data': mainMapLines
                });
                this.map.addSource('gipps-map', {
                    'type': 'geojson',
                    'data': gippsMap
                });
                this.map.addSource('state-lines', {
                    'type': 'geojson',
                    'lineMetrics': true,
                    'data': stateLines
                });
                this.map.addSource('gipps-map-lines', {
                    'type': 'geojson',
                    'data': gippsMapLines
                });
                this.map.addSource('driving-hours', {
                    'type': 'geojson',
                    'data': drivingHours
                });
                this.map.addSource('driving-routes', {
                    'type': 'geojson',
                    'data': drivingRoutes
                });
                this.map.addSource('driving-markers', {
                    'type': 'geojson',
                    'data': drivingMarkers
                });
                this.map.addSource('driving-lines', {
                    'type': 'geojson',
                    'data': drivingLines
                });
                this.map.addSource('park-markers', {
                    'type': 'geojson',
                    'data': parkMarkers
                });
                this.map.addSource('park-places-points', {
                    'type': 'geojson',
                    'data': parkPlacesPoints
                });
                this.map.addSource('driving-routes-segmented', {
                    'type': 'geojson',
                    'data': drivingRoutesSegmented
                });
                this.map.addSource('places-points', {
                    'type': 'geojson',
                    'data': placesPoints
                });
                this.map.addSource('map-labels', {
                    'type': 'geojson',
                    'data': mapLabels
                });
                this.map.addSource('map-lakes', {
                    'type': 'geojson',
                    'data': lakePolygons
                });
                this.map.addSource('map-lakes-line', {
                    'type': 'geojson',
                    'data': lakeLines
                });
                if (!((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)))) {
                    this.map.addSource("sea", {
                        "type": "image",
                        "url": seaImage,
                        "coordinates": [
                            [141.875, -34.782],
                            [153.438, -34.782],
                            [153.438, -41.285],
                            [141.875, -41.285]
                        ]
                    });
                    this.map.addLayer({
                        "id": "overlay",
                        "source": "sea",
                        "type": "raster",
                        "paint": {
                            "raster-opacity": 1
                        }
                    });
                }
                this.map.addLayer({
                    'id': 'main-map-layer',
                    'type': 'fill',
                    'source': 'main-map',
                    'paint': {
                        'fill-color': '#edecea',
                    }
                });
                this.map.addLayer({
                    'id': 'main-map-lines-layer',
                    'type': 'line',
                    'source': 'main-map-lines',
                    'layout': {},
                    'paint': {
                        'line-color': '#fff',
                        'line-width': 2
                    }
                });
                if (!((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)))) {
                    this.map.addSource("white-overlay", {
                        "type": "image",
                        "url": whiteOverlay,
                        "coordinates": [
                            [142.222, -35.221], // bottom right
                            [151.481, -35.221], //top right
                            [151.481, -40.172], //top left
                            [142.222, -40.172] //bottom left
                        ]
                    });
                    this.map.addLayer({
                        "id": "white-overlay",
                        "source": "white-overlay",
                        "type": "raster",
                        "paint": {
                            "raster-opacity": 1
                        }
                    });
                }
                this.map.addLayer({
                    'id': 'gipps-map-layer',
                    'type': 'fill',
                    'source': 'gipps-map',
                    'layout': {
                        'visibility': 'visible',
                    },
                    'paint': {
                        'fill-color': ['get', 'fill-color'],
                        'fill-opacity': [
                            'case',
                            ['boolean', ['feature-state', 'hover'], false],
                            0.80,
                            1
                        ]
                    }
                });
                this.map.addLayer({
                    'id': 'gipps-map-green-layer',
                    'type': 'fill',
                    'source': 'gipps-map',
                    'layout': {
                        'visibility': 'none',
                    },
                    'paint': {
                        'fill-color': '#639263',
                        'fill-opacity': 1
                    }
                });
                this.map.addLayer({
                    'id': 'gipps-map-blue-layer',
                    'type': 'fill',
                    'source': 'gipps-map',
                    'layout': {
                        'visibility': 'none',
                    },
                    'paint': {
                        'fill-color': '#5A889B',
                        'fill-opacity': 1
                    }
                });
                this.map.addLayer({
                    'id': 'state-lines-layer',
                    'type': 'line',
                    'source': 'state-lines',
                    'layout': {},
                    'paint': {
                        'line-color': '#fff',
                        'line-width': 2,
                        'line-gradient': [
                            'interpolate',
                            ['linear'],
                            ['line-progress'],
                            0,
                            'white',
                            1,
                            'transparent'
                        ]
                    },
                    layout: {
                        'line-cap': 'round'
                    }
                });
                this.map.addLayer({
                    'id': 'gipps-map-lines-layer',
                    'type': 'line',
                    'source': 'gipps-map-lines',
                    'layout': {
                        'visibility': 'visible',
                    },
                    'paint': {
                        'line-color': '#fff',
                        'line-width': 2
                    }
                });
                this.map.addLayer({
                    'id': 'gipps-map-lines-layer-blue',
                    'type': 'line',
                    'source': 'gipps-map-lines',
                    'layout': {
                        'visibility': 'none',
                    },
                    'paint': {
                        'line-color': '#80ADC0',
                        'line-width': 2
                    }
                });
                this.map.addLayer({
                    'id': 'gipps-map-lines-layer-green',
                    'type': 'line',
                    'source': 'gipps-map-lines',
                    'layout': {
                        'visibility': 'none',
                    },
                    'paint': {
                        'line-color': '#83B183',
                        'line-width': 2
                    }
                });
                this.map.addLayer({
                    'id': 'lakes-polygon-layer',
                    'type': 'fill',
                    'source': 'map-lakes',
                    'layout': {
                        'visibility': 'visible'
                    },
                    'paint': {
                        'fill-color': '#AEDEF7',
                        'fill-opacity': 1
                    }
                });
                this.map.addLayer({
                    'id': 'lakes-lines-layer',
                    'type': 'line',
                    'source': 'map-lakes-line',
                    'layout': {
                        'visibility': 'visible'
                    },
                    'paint': {
                        'line-width': 2,
                        'line-color': '#fff'
                    }
                });
                this.map.addLayer({
                    'id': 'driving-lines-layer',
                    'type': 'line',
                    'source': 'driving-lines',
                    'layout': {},
                    'paint': {
                        'line-color': ['get', 'line-color'],
                        'line-width': 2,
                    },
                    layout: {
                        'line-cap': 'round',
                        'visibility': 'none',
                    }
                });
                this.map.addLayer({
                    'id': 'region-custom-label-layer',
                    'type': 'symbol',
                    'source': 'map-labels',
                    'layout': {
                        'icon-image': 'map-marker',
                        'text-field': ['get', 'title'],
                        'text-font': [
                            'DIN Pro Bold',
                            'Arial Unicode MS Bold'
                        ],
                        'text-offset': ['get', 'textOffset'],
                        'text-anchor': 'top',
                        'text-size': 12.5,
                        'visibility': 'visible',
                        'icon-allow-overlap': true,
                    },
                    paint: {
                        'text-color': "#ffffff"
                    }
                });
                this.map.addLayer({
                    'id': 'region-places-points-layer',
                    'type': 'symbol',
                    'source': 'places-points',
                    'layout': {
                        'icon-image': ['get', 'marker'],
                        'text-field': ['get', 'title'],
                        'text-font': [
                            'DIN Pro Bold',
                            'Arial Unicode MS Bold'
                        ],
                        'text-offset': ['get', 'textOffset'],
                        'text-anchor': 'top',
                        'text-size': 12.5,
                        'visibility': 'visible',
                        'icon-allow-overlap': true,
                    },
                    'paint': {
                        'text-color': ['get', 'textColor']
                    }
                });
                this.map.addLayer({
                    'id': 'park-places-points-layer',
                    'type': 'symbol',
                    'source': 'park-places-points',
                    'layout': {
                        'icon-image': ['get', 'marker'],
                        'text-field': ['get', 'title'],
                        'text-font': [
                            'DIN Pro Bold',
                            'Arial Unicode MS Bold'
                        ],
                        'text-offset': ['get', 'textOffset'],
                        'text-anchor': 'top',
                        'text-size': 12.5,
                        'visibility': 'visible',
                    },
                    'paint': {
                        'text-color': ['get', 'textColor']
                    }
                });
                this.map.addLayer({
                    'id': 'driving-routes-layer-stroke',
                    'type': 'line',
                    'source': 'driving-routes-segmented',
                    'layout': {
                        'visibility': 'none',
                    },
                    'paint': {
                        'line-color': '#fff',
                        'line-width': 3,
                        'line-opacity': 0.6
                    }
                });
                this.map.addLayer({
                    'id': 'driving-routes-layer',
                    'type': 'line',
                    'source': 'driving-routes-segmented',
                    'layout': {
                        'visibility': 'none',
                        'line-cap': 'round'
                    },
                    'paint': {
                        'line-color': '#fff',
                        'line-width': 5,
                        'line-opacity': [
                            'case',
                            ['boolean', ['feature-state', 'hover'], false],
                            1,
                            0
                        ]
                    }
                });
                this.map.addLayer({
                    'id': 'driving-routes-segmented-layer',
                    'type': 'line',
                    'source': 'driving-routes-segmented',
                    'layout': {
                        'visibility': 'none',
                    },
                    'paint': {
                        'line-color': '#A4A838',
                        'line-width': 3,
                        'line-opacity': [
                            'case',
                            ['boolean', ['feature-state', 'hover'], false],
                            1,
                            0
                        ]
                    }
                });
                this.map.addLayer({
                    'id': 'driving-markers-layer',
                    'type': 'symbol',
                    'source': 'driving-markers',
                    'layout': {
                        'icon-image': ['get', 'marker'],
                        'text-field': ['get', 'title'],
                        'text-font': [
                            'DIN Pro Bold',
                            'Arial Unicode MS Bold'
                        ],
                        'text-offset': ['get', 'textOffset'],
                        'text-anchor': 'top',
                        'text-size': 14,
                        'visibility': 'none',
                        'icon-allow-overlap': true,
                    },
                    'paint': {
                        'text-color': ['get', 'textColor']
                    }
                });
                this.map.addLayer({
                    'id': 'park-markers-layer',
                    'type': 'symbol',
                    'source': 'park-markers',
                    'layout': {
                        'icon-image': ['get', 'marker'],
                        'text-field': ['get', 'title'],
                        'text-font': [
                            'DIN Pro Bold',
                            'Arial Unicode MS Bold'
                        ],
                        'text-offset': ['get', 'textOffset'],
                        'text-anchor': 'top',
                        'text-size': 14,
                        'visibility': 'none',
                        'icon-allow-overlap': true,
                    },
                    'paint': {
                        'text-color': ['get', 'textColor']
                    }
                });
                this.map.addLayer({
                    'id': 'driving-hours-markers-layer',
                    'type': 'symbol',
                    'source': 'driving-hours',
                    'layout': {
                        'icon-image': ['get', 'marker'],
                        'icon-allow-overlap': true,
                        'visibility': 'none',
                    }
                });
                this.map.on('click', 'region-custom-label-layer', function (e) {
                    if (e.features[0].properties.id == 'label-philip-island') {
                        self.polygonClick(e);
                    }
                });
                this.map.on('click', 'gipps-map-layer', function (e) {
                    self.polygonClick(e);
                });
                this.map.on('mousemove', 'gipps-map-layer', function (e) {
                    self.map.getCanvas().style.cursor = 'pointer';
                    if (e.features.length > 0) {
                        if (self.hoveredStateId) {
                            self.map.setFeatureState({
                                source: 'gipps-map',
                                id: self.hoveredStateId
                            }, {
                                hover: false
                            });
                        }
                        self.hoveredStateId = e.features[0].id;
                        self.map.setFeatureState({
                            source: 'gipps-map',
                            id: self.hoveredStateId
                        }, {
                            hover: true
                        });
                    }
                });
                this.map.on('mouseleave', 'gipps-map-layer', function () {
                    self.map.getCanvas().style.cursor = '';
                    self.map.setFeatureState({
                        source: 'gipps-map',
                        id: self.hoveredStateId
                    }, {
                        hover: false
                    });
                    self.hoveredStateId = null;
                });
                this.map.on('mouseenter', 'driving-hours-markers-layer', function () {
                    self.map.getCanvas().style.cursor = 'pointer';
                });
                this.map.on('mouseleave', 'driving-hours-markers-layer', function () {
                    self.map.getCanvas().style.cursor = '';
                });
                this.map.on('click', 'driving-hours-markers-layer', function (e) {
                    if (e.features.length > 0) {
                        if (self.hoveredStateId) {
                            self.map.setFeatureState({
                                source: 'driving-routes-segmented',
                                id: self.hoveredStateId
                            }, {
                                hover: false
                            });
                        }
                        self.hoveredStateId = e.features[0].id;
                        self.map.setFeatureState({
                            source: 'driving-routes-segmented',
                            id: self.hoveredStateId
                        }, {
                            hover: true
                        });
                    }

                    var lng = parseFloat(e.features[0].properties.centerLng);
                    var lat = parseFloat(e.features[0].properties.centerLat);

                    if (self.openedPopupName) {
                        if (self.openedPopupName !== e.features[0].properties.name) {
                            self.popup.remove();
                        } else {
                            return false;
                        }
                    }

                    self.popup = new mapboxgl.Popup({
                            closeButton: false,
                            className: 'popup popup-drive-times',
                            anchor: e.features[0].properties.anchor
                        })
                        .setLngLat({
                            "lng": lng,
                            "lat": lat
                        })
                        .setHTML(
                            '<h3 class="h3">' + e.features[0].properties.from +
                            '</h3><span>&harr;</span><h3 class="h3">' + e.features[0].properties.to +
                            '</h3><span class="time">' + e.features[0].properties.drivingTime +
                            '</span>'
                        )
                        .setMaxWidth('250px')
                        .addTo(self.map);
                    self.map.dragPan.enable();

                    self.openedPopupName = e.features[0].properties.name;

                    self.popup.on('close', function (e) {
                        setTimeout(function () {
                            self.popUpContainer = document.getElementsByClassName("popup")[0];
                            if (self.popUpContainer) {
                                return false;
                            } else {
                                self.openedPopupName = null;
                            }

                            self.map.setFeatureState({
                                source: 'driving-routes-segmented',
                                id: self.hoveredStateId
                            }, {
                                hover: false
                            });
                            self.hoveredStateId = null;
                        }, 200);
                    })
                });
                this.map.on('mouseenter', 'park-markers-layer', function () {
                    self.map.getCanvas().style.cursor = 'pointer';
                });
                this.map.on('mouseleave', 'park-markers-layer', function () {
                    self.map.getCanvas().style.cursor = '';
                });
                this.map.on('click', 'park-markers-layer', function (point) {
                    var lng = parseFloat(point.features[0].properties.centerLng);
                    var lat = parseFloat(point.features[0].properties.centerLat);
                    var coordinates = point.features[0].geometry.coordinates.slice();
                    self.map.getCanvas().style.cursor = 'pointer';

                    if (self.openedPopupName) {
                        if (self.openedPopupName !== point.features[0].properties.name) {
                            self.popup.remove();
                        } else {
                            return false;
                        }
                    }

                    self.popup = new mapboxgl.Popup({
                            closeButton: false,
                            className: 'popup'
                        })
                        .setLngLat({
                            "lng": lng,
                            "lat": lat
                        })
                        .setHTML(
                            '<div class="pop-up__header"><div class="pop-up__header-text"><h3 class="fancy-text">Discover</h3><h1 class="h2">' +
                            point.features[0].properties.name + '</h1></div><img style="width: 100%;" src="' +
                            point.features[0].properties.image + '"/></div><a class="popup__link" target="_blank" href="' +
                            point.features[0].properties.link + '">FIND OUT MORE</a>'
                        )
                        .setMaxWidth('420px')
                        .addTo(self.map);
                    self.map.dragPan.enable();

                    self.openedPopupName = point.features[0].properties.name;

                    self.popup.on('close', function (e) {
                        setTimeout(function () {
                            self.popUpContainer = document.getElementsByClassName("popup")[0];
                            if (self.popUpContainer) {
                                return false;
                            } else {
                                self.openedPopupName = null;
                                self.map.getCanvas().style.cursor = '';
                            }
                        }, 200);
                    })
                });

                // disable pan for large screens.

                self.windowResize(self.panEnabledWindowSize); // Call listener function at run time
                self.panEnabledWindowSize.addListener(self.windowResize);

                // set up the corresponding toggle button for each layer
                for (var i = 0; i < this.mapTabs.length; i++) {
                    const link = document.createElement('li');

                    link.className = (i === 0) ? 'map-tab__active map-tab map-tab__' + self.mapTabs[i].id : 'map-tab map-tab__' + self.mapTabs[i].id;
                    link.textContent = self.mapTabs[i].name;
                    link.id = self.mapTabs[i].id;

                    link.onclick = function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (self.openedPopupName) {
                            self.popup.remove();
                        }
                        const selected = this;
                        self.selectedTab = selected.id;
                        const oldActiveElement = document.querySelector('.map-tab__active');
                        oldActiveElement.classList.remove('map-tab__active');

                        for (let a = 0; a < self.mapTabs.length; a++) {
                            if (self.mapTabs[a].id === self.selectedTab) {
                                selected.classList.add('map-tab__active');
                                const clickedLayer = self.mapTabs[a];
                                const visibleLayers = clickedLayer.visibleLayers;
                                for (let b = 0; b < visibleLayers.length; b++) {
                                    const visibility = self.map.getLayoutProperty(visibleLayers[b], 'visibility');
                                    // toggle layer visibility by changing the layout object's visibility property
                                    self.map.setLayoutProperty(visibleLayers[b], 'visibility', 'visible');
                                }
                            } else {
                                const hideLayer = self.mapTabs[a];
                                const hideLayers = hideLayer.visibleLayers;
                                for (let c = 0; c < hideLayers.length; c++) {
                                    const visibility = self.map.getLayoutProperty(hideLayers[c], 'visibility');
                                    // toggle layer visibility by changing the layout object's visibility property
                                    self.map.setLayoutProperty(hideLayers[c], 'visibility', 'none');
                                }
                            }
                        }
                    };

                    const layers = document.getElementById('map-tabs');
                    layers.appendChild(link);
                }
            });
        },
        polygonClick(polygon) {
            const self = this;
            const lng = parseFloat(polygon.features[0].properties.centerLng);
            const lat = parseFloat(polygon.features[0].properties.centerLat);
            self.popup = new mapboxgl.Popup({
                    closeButton: false,
                    className: 'popup'
                })
                .setLngLat({
                    "lng": lng,
                    "lat": lat
                })
                .setHTML(
                    '<div class="pop-up__header"><div class="pop-up__header-text"><h3 class="fancy-text">Discover</h3><h1 class="h2">' +
                    polygon.features[0].properties.name + '</h1></div><img style="width: 100%;" src="' +
                    polygon.features[0].properties.image + '"/></div><p class="pop-up__description">' +
                    polygon.features[0].properties.description + '</p><a class="popup__link" target="_blank" href="' +
                    polygon.features[0].properties.link + '">FIND OUT MORE</a>'
                )
                .setMaxWidth('420px')
                .addTo(self.map);
            self.map.flyTo({
                center: [lng, lat],
                zoom: self.maxZoom
            });
            self.map.dragPan.enable();

            self.openedPopupName = polygon.features[0].properties.name;

            self.popup.on('close', function (e) {
                setTimeout(function () {
                    self.popUpContainer = document.getElementsByClassName("popup")[0];
                    if (self.popUpContainer) {
                        return false;
                    } else {
                        self.windowResize(self.panEnabledWindowSize);
                        self.map.flyTo({
                            center: [147.84, -37.805],
                            zoom: self.minZoom
                        });
                        self.openedPopupName = null;
                    }
                }, 200);
            })
        },
        windowResize(windowSize) {
            const self = this;
            if (windowSize.matches) { // If media query matches
                self.map.dragPan.enable();
            } else {
                self.map.dragPan.disable();
                setTimeout(function () {
                    self.checkZoomLevel();
                }, 500);
            }
        },
        checkZoomLevel() {
            const self = this;
            var currentZoom = self.map.getZoom();
            if (currentZoom > self.minZoom) {
                self.map.dragPan.enable();
            } else {
                self.map.jumpTo({
                    center: [147.84, -37.805]
                });
                self.map.dragPan.disable();
            }
        }
    },
};
</script>
<style lang="scss">
.mapbox {
    position: relative;

    @include media-query('portable') {
        display: none;
    }
}

.mapbox__container {
    width: 100%;
    height: 100vh;
}

.mapboxgl-popup {
    width: 420px;
    opacity: 0;
    transition: opacity 0.8s ease;
}

.mapboxgl-popup.popup-drive-times {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
}

.mapboxgl-popup.popup-drive-times .mapboxgl-popup-content {
    text-align: center;
    padding: 10px !important;
    min-height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.mapboxgl-popup.popup-drive-times h3{
    color: #505C63;
    font-size: 18px;
    margin: 0;
}

.mapboxgl-popup.popup-drive-times .mapboxgl-popup-content span {
    color: #023c48;
    font-weight: 700;
    font-size: 16px;
}

.mapboxgl-popup.popup-drive-times .mapboxgl-popup-content span.time {
    display: inline-block;
    margin-top: 10px;
}

.mapboxgl-popup.mapboxgl-popup-anchor-top, .mapboxgl-popup.mapboxgl-popup-anchor-bottom, .mapboxgl-popup.mapboxgl-popup-anchor-right, .mapboxgl-popup.mapboxgl-popup-anchor-left {
    opacity: 1;
}

.mapboxgl-popup .pop-up__header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 134px;
    min-height: 134px;
    overflow: hidden;
    background: #fff;
}

.mapboxgl-popup .pop-up__header:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.2);
    left: 0;
    top: 0;
    z-index: 1;
}

.mapboxgl-popup .pop-up__header-text {
    position: absolute;
    z-index: 2;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
}

.mapboxgl-popup .pop-up__description {
    font-size: 18px;
    padding: 20px 30px 0px;
    font-family: $base-font-family;
    margin-bottom: 0px;
    text-align: center;
}

.mapboxgl-popup .popup__link {
    background-color: #0c5987;
    color: #fff;
    display: block;
    text-decoration: none;
    padding: .6rem 2.5rem;
    font-size: 14px;
    max-width: 200px;
    margin: 20px auto 30px;
    text-align: center;
    font-family: $base-font-family;
    font-weight: 700;
    white-space: nowrap;
}

.mapboxgl-popup .pop-up__header-text h1 {
    color: #fff;
    font-size: 35px;
    margin: 0px;
    padding: 0 20px;
}

.mapboxgl-popup .fancy-text {
    font-family: $fancy-font-family;
    color: #fff;
    margin: 0;
    font-size: 18px;
}

/* Mapbox style overrides */

.mapboxgl-popup-content {
    padding: 0 !important;
}

.mapboxgl-popup-close-button {
    z-index: 5;
    font-size: 20px;
    color: #FFF;
}

.mapboxgl-ctrl-bottom-left {
    left: auto;
    right: 10px;
    bottom: 20px;
}

.mapboxgl-ctrl.mapboxgl-ctrl-attrib {
    background: transparent !important;
}

.mapbox__side-bar {
    position: absolute;
    z-index: 20;
    top: 20px;
    left: 20px;
    padding: 30px 30px 20px;
    background: rgba(255,255,255,0.5);
    border-radius: 20px;
}

.mapbox__side-bar .main-header{
    font-family: $heading-font-family;
    text-transform: uppercase;
    font-size: 4rem;
    color: #000;
    margin-top: 0px;
    margin-bottom: 30px;
}

#map-tabs {
    list-style: none;
    margin: 0;
    padding: 0;
}

#map-tabs li {
    font-size: 14px;
    text-transform: uppercase;
    color: #023c48;
    display: block;
    margin: 0;
    padding: 0;
    padding: 10px;
    font-family: 'DIN', Helvetica, sans-serif;
    font-weight: 700;
    display: flex;
    align-items: center;
    padding: 15px 20px;
    margin: 5px 0;
    border-radius: 100px;
    min-width: 185px;
    max-width: 185px;
}

#map-tabs li.map-tab__active {
    color: #fff;
    background-color: #023c48;
}

#map-tabs li::before{
    content: '';
    width: 20px;
    height: 20px;
    display: block;
    margin-right: 10px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}

#map-tabs li:hover{
    cursor: pointer;
}

li.map-tab__regions::before, li.map-tab__show-all::before{
    background-image: url('../assets/images/icon-regions-gray.svg');

}

li.map-tab__drive-times::before{
    background-image: url('../assets/images/icon-drive-gray.svg');
}

li.map-tab__national-parks::before{
    background-image: url('../assets/images/icon-leaf-gray.svg');
}

li.map-tab__regions.map-tab__active::before, li.map-tab__show-all.map-tab__active::before{
    background-image: url('../assets/images/icon-regions.svg');
}

li.map-tab__drive-times.map-tab__active::before{
    background-image: url('../assets/images/icon-drive.svg');
}

li.map-tab__national-parks.map-tab__active::before{
    background-image: url('../assets/images/icon-leaf.svg');
}

li.map-tab__stay::before{
    background-image: url('../assets/images/icon-accomodation-gray.svg');
}

li.map-tab__stay.map-tab__active::before{
    background-image: url('../assets/images/icon-accomodation.svg');
}

li.map-tab__activity::before{
    background-image: url('../assets/images/icon-cycling-gray.svg');
}

li.map-tab__activity.map-tab__active::before{
    background-image: url('../assets/images/icon-cycling.svg');
}

li.map-tab__nature-and-wildlife::before{
    background-image: url('../assets/images/icon-leaf-gray.svg');
}

li.map-tab__nature-and-wildlife.map-tab__active::before{
    background-image: url('../assets/images/icon-leaf.svg');
}

li.map-tab__eat-and-drink::before{
    background-image: url('../assets/images/icon-wine-gray.svg');
}

li.map-tab__eat-and-drink.map-tab__active::before{
    background-image: url('../assets/images/icon-wine.svg');
}

li.map-tab__art-and-culture::before{
    background-image: url('../assets/images/icon-art-gray.svg');
}

li.map-tab__art-and-culture.map-tab__active::before{
    background-image: url('../assets/images/icon-art.svg');
}

#map-tabs a:last-child {
    border: none;
}

#map-tabs a:hover {
    background-color: #f8f8f8;
    color: #404040;
}

#map-tabs a.map-tab__active {
    background-color: #3887be;
    color: #ffffff;
}

#map-tabs a.map-tab__active:hover {
    background: #3074a4;
}

</style>